var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceRevenuePenetrationImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9375 15.3438L13.1875 18.2188L7.4375 17.8594L6 18.9375L4.20312 17.1406L5.74484 15.5989L7.4375 13.9062H12.4688V15.3438L13.1875 16.0625L17.8378 14.2009L18.5781 13.9062L18.9375 15.3438Z",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4688 15.3438H9.59375",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18.9375L7.07812 20.0156L6 21.0938L1.6875 16.7812L2.76562 15.7031L4.20312 17.1406",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 21.0938L4.5625 22.5312L0.25 18.2188L1.6875 16.7812",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59375 12.4688C12.9679 12.4688 15.7031 9.73349 15.7031 6.35938C15.7031 2.98526 12.9679 0.25 9.59375 0.25C6.21964 0.25 3.48438 2.98526 3.48438 6.35938C3.48438 9.73349 6.21964 12.4688 9.59375 12.4688Z",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8281 13.18C14.1188 12.5678 15.2091 11.6018 15.9725 10.3945C16.7359 9.18708 17.141 7.78784 17.1406 6.35938",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04688 6.35938C2.04665 7.78772 2.45177 9.18681 3.21516 10.394C3.97854 11.6013 5.06885 12.5671 6.35938 13.1792",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9551 14.625C15.4592 13.8312 16.7182 12.6419 17.5963 11.1853C18.4743 9.72875 18.9382 8.06014 18.9378 6.35938",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 6.35938C0.249702 8.06022 0.713659 9.72888 1.59185 11.1855C2.47005 12.642 3.72916 13.8313 5.23345 14.625",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59375 11.0312C12.174 11.0312 14.2656 8.93958 14.2656 6.35938C14.2656 3.77917 12.174 1.6875 9.59375 1.6875C7.01354 1.6875 4.92188 3.77917 4.92188 6.35938C4.92188 8.93958 7.01354 11.0312 9.59375 11.0312Z",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79688 4.5625H9.59375C9.87969 4.5625 10.1539 4.67609 10.3561 4.87828C10.5583 5.08046 10.6719 5.35469 10.6719 5.64062C10.6719 5.92656 10.5583 6.20079 10.3561 6.40297C10.1539 6.60516 9.87969 6.71875 9.59375 6.71875H8.15625L10.3125 8.875",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15625 4.5625H11.3906",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79688 5.64062H11.3906",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59375 1.6875V0.25",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59375 12.4688V11.0312",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2656 6.35938H15.7031",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48438 6.35938H4.92188",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8975 9.66211L13.9141 10.6788",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27344 2.03906L6.29011 3.05573",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8975 3.05573L13.9141 2.03906",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27344 10.6788L6.29011 9.66211",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceRevenuePenetrationImg);
export default __webpack_public_path__ + "static/media/service_revenue_penetration_img.aebfca587b495bbdd6580f4429efc34e.svg";
export { ForwardRef as ReactComponent };